import { DATA_MODEL_TABLE } from "@digitallab/grid-common-components";
import { OwcSlideToggle, OwcTextarea } from "@one/react";
import { FormikProps } from "formik";
import { react18WorkaroundProps } from "../../../../utils/constants/react18WorkaroundProps";
import { useFieldPropagationToggle } from "../../../../utils/hooks/useFieldPropagationToggle";
export const ConfigurationDetailsWithSwitch = ({
  formik,
  isPropagationDisabled,
  numberOfSelectedEquipment,
  editMode,
  defaultValue
}: {
  formik: FormikProps<{
    logbookConfigurationDetails: { newValue: string; shouldBePublished: boolean };
    action: string;
  }>;
  isPropagationDisabled?: boolean;
  numberOfSelectedEquipment: number;
  editMode: boolean;
  defaultValue: string;
}) => {
  const isBulk = numberOfSelectedEquipment > 1;
  const bulkDefaultValue = numberOfSelectedEquipment > 1 ? '' : defaultValue;

  const { isToggleDisabled } = useFieldPropagationToggle({
    formikValue: formik.values.logbookConfigurationDetails,
    defaultValue: bulkDefaultValue,
    label: "logbookConfigurationDetails",
    setFieldValue: formik.setFieldValue,
    disabled: editMode || isPropagationDisabled
  });
  return (
    <>
      <div className="owcInputBox" style={{ width: "100%" }}>
        {formik && (
          <OwcTextarea
            id="logbookConfigurationDetails.newValue"
            label={DATA_MODEL_TABLE.configurationDetails.value}
            style={{ minHeight: 136 }}
            rows={8}
            maxLength={500}
            {...react18WorkaroundProps}
            placeholder={DATA_MODEL_TABLE.configurationDetails.value}
            value={formik.values.logbookConfigurationDetails?.newValue}
            onBlur={formik.handleBlur}
            onInputChange={formik.handleChange}
            onInputKeyDown={formik.handleChange}
            assistiveText={isBulk ? "Empty means “Keep current values”, Filled means “Set all to new value”" : undefined}
          />
        )}
      </div>
      <OwcSlideToggle
        style={{ marginTop: isBulk ? "-0.5rem" : "-1.5rem" }}
        checked={formik.values.logbookConfigurationDetails?.shouldBePublished}
        onInputChange={(event: { detail: boolean }) =>
          formik.setFieldValue("logbookConfigurationDetails.shouldBePublished", event.detail)
        }
        id="logbookConfigurationDetails.shouldBePublished"
        disabled={editMode || isPropagationDisabled || isToggleDisabled}
        {...react18WorkaroundProps}
      >
        Publish “Configuration details” to Equipment Repository
      </OwcSlideToggle>
    </>
  );
}
